import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';
import { SubmissionError } from 'redux-form';

import { authLoginUserFailure, authUpdateUser } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
    uploadProfileImage,
    fetchProfile,
    patchProfile,
    postSetPassword,
    fetchTickets,
    fetchContact,
    createTicket,
    uploadTicketImage,
    createTicketAttachment,
    fetchTicket,
    postComment,
    fetchComments
  } from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const PROFILE_FETCH_FAILURE = 'PROFILE_FETCH_FAILURE';
export const PROFILE_FETCH_REQUEST = 'PROFILE_FETCH_REQUEST';
export const PROFILE_FETCH_SUCCESS = 'PROFILE_FETCH_SUCCESS';
export const PROFILE_EDIT_FAILURE = 'PROFILE_EDIT_FAILURE';
export const PROFILE_EDIT_REQUEST = 'PROFILE_EDIT_REQUEST';
export const PROFILE_EDIT_SUCCESS = 'PROFILE_EDIT_SUCCESS';
export const PASSWORD_SET_FAILURE = 'PASSWORD_SET_FAILURE';
export const PASSWORD_SET_REQUEST = 'PASSWORD_SET_REQUEST';
export const PASSWORD_SET_SUCCESS = 'PASSWORD_SET_SUCCESS';
export const TICKET_FETCH_SUCCESS = 'TICKET_FETCH_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------

export function gotoProfile() {
  return (dispatch) => {
    dispatch(push('/profile'));
  };
}
export function gotoProfileEdit() {
  return (dispatch) => {
    dispatch(push('/profile/edit'));
  };
}
export function gotoProfilePassword() {
  return (dispatch) => {
    dispatch(push('/profile/password'));
  };
}
export function requestingProfile() {
  return {
    type: PROFILE_FETCH_REQUEST,
    payload: null,
  };
}
export function requestTicketSuccess(json) {
  return {
    type: TICKET_FETCH_SUCCESS,
    payload: json,
  };
}
export function requestProfileFailure(json) {
  return {
    type: PROFILE_FETCH_FAILURE,
    payload: json,
  };
}

export function requestTickets(cb) {
    return (dispatch) => {
      return fetchTickets()
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          dispatch(requestTicketSuccess(response));
          cb(response)
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  } 

  export function requestContact(cb) {
    return (dispatch) => {
      //dispatch(requestingProfile());
      return fetchContact()
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          cb(response)
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  }

  export function addTicket(payload) {
    return (dispatch) => {
      //dispatch(requestingProfile());
      return createTicket(payload)
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          const notificationOpts = {
            title: 'Congrats!',
            message: 'Ticket created successfully.',
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));  
          //cb(response)
          dispatch(push(`/support`));
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  }

  export function uploadImage(payload,cb) {
    return (dispatch) => {
      return uploadTicketImage(payload)
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          const notificationOpts = {
            title: 'Congrats!',
            message: 'Attachment uploaded successfully.',
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));  
          cb(response)
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  }

  export function addTicketWithAttchment(payload) {
    return (dispatch) => {
      //dispatch(requestingProfile());
      return createTicketAttachment(payload)
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          const notificationOpts = {
            title: 'Congrats!',
            message: 'Ticket created successfully.',
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));  
          dispatch(push(`/support`));
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  }

  export function requestTicket(payload,cb) {
    return (dispatch) => {
      //dispatch(requestingProfile());
      return fetchTicket(payload)
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          //dispatch(requestTicketSuccess(response));
          cb(response)
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  } 

  export function addComment(payload) {
    return (dispatch) => {
      //dispatch(requestingProfile());
      return postComment(payload)
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          const notificationOpts = {
            title: 'Congrats!',
            message: 'Comment added successfully.',
            autoDismiss: 15,
          };
          //dispatch(requestTicketSuccess(response));
          dispatch(Notifications.success(notificationOpts));
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  }

  export function requestComments(payload,cb) {
    return (dispatch) => {
      //dispatch(requestingProfile());
      return fetchComments(payload)
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((response) => {
          //dispatch(requestTicketSuccess(response));
          cb(response)
        })
        .catch((error) => {
          if (error && typeof error.response !== 'undefined') {
            const status = error.response.status;
            if (status === 400) {
              error.response.json().then((detail) => {
                console.log('400: ', detail);
                return dispatch(requestProfileFailure(detail));
  
              });
            } else if (status >= 401 && status <= 403) {
                // Invalid authentication credentials
              return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                // const redirectAfterLogin = this.props.location.pathname;
                return dispatch(push('/login'));
              });
            } else if (status >= 404) {
              console.log('Yikes problem with server. ', status);
            }
          } else {
            // Most likely connection issues
            console.log('An error occurred while sending your data!');
          }
          Promise.resolve();
          // TODO: we need a promise here because of the tests, find a better way
        });
    };
  }



// export function profileEditRequest() {
//   return {
//     type: PROFILE_EDIT_REQUEST,
//     payload: null,
//   };
// }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TICKET_FETCH_SUCCESS]: (state,action) => {
    if (action.payload.length !== 0) {
      return update(
        state,
        {
          $set:
          {
            tickets: action.payload.ticketlist,
          },
        },
      );
    }
  },  
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true,
  needFetch: true,
  tickets: {},
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/support/modules/support.js